/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* Accedo Build XDK Device Package - Samsung Tizen (@accedo/xdk-device-samsung-tizen) 4.2.5
* 
*******************************************************************************/
import{detection as detect}from"@accedo/xdk-core";function isTizen(){return"undefined"!=typeof tizen}const detection=detect(isTizen);export default detection;